import { ServiceReservationSurveyAnswer } from "../../../graphql/models";

export interface ServiceReservationSurveyProps {
  items: ServiceReservationSurveyAnswer[];
}

export function ServiceReservationSurvey(props: ServiceReservationSurveyProps) {
  const { items } = props;
  return (
    <div>
      {items.map((item) => (
        <p>
          <strong>Q: {item.question}</strong>
          <br />
          <span>A: {item.answer}</span>
        </p>
      ))}
    </div>
  );
}
